import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserService } from '../shared/services/user.service';
import { FundraisingService } from '../shared/services/fundraising.service';
import { Message, SelectItem } from 'primeng/primeng';
import { CommonDataService } from '../shared/services/common-data.service';
import { SettingsService } from '../shared/services/settings.service';
import { SessionService } from '../shared/services/session.service';
import { ConfigService } from '../config/config.service';
import { FundrasingAccount } from '../shared/classes/fundraisingaccount';
import { window } from 'rxjs/operators';

@Component({
    selector: 'app-create-account',
    templateUrl: './create-account.component.html',
    styleUrls: ['./create-account.component.css']
})
export class CreateAccountComponent implements OnInit {

    hideUI: boolean = false;
    createAccount: FormGroup;
    msg: Message[];
    submitted: boolean = false;
    market: string;

    organizationTypeList = [];
    regionTypeList = [];
    stateTypeList = [];
    titleTypeList = [];
    salesRepList = [];


    phone:string='';
    organizationphone:string='';

    fundrasingAccount: FundrasingAccount = {
        organizationname: null, 
        organizatintype: null,
        salesRep: null,
        region: null,
        title: null,
        email: null,
        city: null,
        state: null,
        address: null,
        zip: null,
        phone: null,
        primarycontact:null,
        organizationphone:null
    };

    constructor(private commonDataService: CommonDataService,
        private userService: UserService,
        private fundraisingService: FundraisingService,
        private _settingsService: SettingsService,
        private sessionService: SessionService,
        private router: Router,


        private configService: ConfigService) {

        // let defaultValue = { id: 'SELECT', value: 'Select' }

        this.createAccount = new FormGroup({
            'organizationname': new FormControl('', Validators.required),
            'organizationtype': new FormControl('', Validators.required),
            'salesRep': new FormControl('', Validators.required),
            'region': new FormControl('', Validators.required),
            'title': new FormControl('', Validators.required),
            'email': new FormControl('', Validators.required),
            'city': new FormControl('', Validators.required),
            'state': new FormControl('', Validators.required),
            'address': new FormControl('', Validators.required),
            'zip': new FormControl('', Validators.required),
            'phone': new FormControl('', Validators.required),
            'primarycontact': new FormControl('', Validators.required),
            'organizationphone': new FormControl('', Validators.required)
        });


        // this.organizationTypeList.push(defaultValue);
        // this.regionTypeList.push(defaultValue);
        // this.stateTypeList.push(defaultValue);
        // this.titleTypeList.push(defaultValue);
        // this.salesRepList.push(defaultValue);

        this.organizationTypeList.push({ id: 'SCHOOL', value: 'School' });
        this.organizationTypeList.push({ id: 'NONPROFIT', value: 'Non-Profit' });

        this.regionTypeList.push({ id: 'SANTA_BARBARA_MARKET', value: 'Santa Barbara' });
        this.regionTypeList.push({ id: 'VENTURA_MARKET', value: 'Ventura' });

        // this.salesRepList.push({ id: 'Ginelle Bongiorno', value: 'Ginelle Bongiorno' });
        // this.salesRepList.push({ id: 'Karim Kaderali', value: 'Karim Kaderali' });
        // this.salesRepList.push({ id: 'Rachel Cantella', value: 'Rachel Cantella' });


        this.stateTypeList.push({ id: 'AK', value: 'AK' });
        this.stateTypeList.push({ id: 'AL', value: 'AL' });
        this.stateTypeList.push({ id: 'AR', value: 'AR' });
        this.stateTypeList.push({ id: 'AZ', value: 'AZ' });
        this.stateTypeList.push({ id: 'CA', value: 'CO' });
        this.stateTypeList.push({ id: 'CT', value: 'DE' });
        this.stateTypeList.push({ id: 'FL', value: 'FL' });
        this.stateTypeList.push({ id: 'GA', value: 'GA' });
        this.stateTypeList.push({ id: 'HI', value: 'HI' });
        this.stateTypeList.push({ id: 'IA', value: 'IA' });
        this.stateTypeList.push({ id: 'ID', value: 'ID' });
        this.stateTypeList.push({ id: 'AK', value: 'AK' });
        this.stateTypeList.push({ id: 'IL', value: 'IL' });
        this.stateTypeList.push({ id: 'IN', value: 'IN' });
        this.stateTypeList.push({ id: 'KS', value: 'KS' });
        this.stateTypeList.push({ id: 'KY', value: 'KY' });
        this.stateTypeList.push({ id: 'LA', value: 'LA' });
        this.stateTypeList.push({ id: 'MA', value: 'MA' });
        this.stateTypeList.push({ id: 'MD', value: 'MD' });
        this.stateTypeList.push({ id: 'ME', value: 'ME' });
        this.stateTypeList.push({ id: 'MI', value: 'MI' });
        this.stateTypeList.push({ id: 'MIN', value: 'MIN' });
        this.stateTypeList.push({ id: 'MO', value: 'MO' });
        this.stateTypeList.push({ id: 'MS', value: 'MS' });
        this.stateTypeList.push({ id: 'MT', value: 'MT' });
        this.stateTypeList.push({ id: 'NC', value: 'NC' });
        this.stateTypeList.push({ id: 'NE', value: 'NE' });
        this.stateTypeList.push({ id: 'NH', value: 'NH' });
        this.stateTypeList.push({ id: 'NJ', value: 'NJ' });
        this.stateTypeList.push({ id: 'NM', value: 'NM' });
        this.stateTypeList.push({ id: 'NV', value: 'NV' });
        this.stateTypeList.push({ id: 'NY', value: 'NY' });
        this.stateTypeList.push({ id: 'OH', value: 'OH' });
        this.stateTypeList.push({ id: 'OK', value: 'OK' });
        this.stateTypeList.push({ id: 'OR', value: 'OR' });
        this.stateTypeList.push({ id: 'PA', value: 'PA' });
        this.stateTypeList.push({ id: 'RI', value: 'RI' });
        this.stateTypeList.push({ id: 'SC', value: 'SC' });
        this.stateTypeList.push({ id: 'SD', value: 'SD' });
        this.stateTypeList.push({ id: 'TN', value: 'TN' });
        this.stateTypeList.push({ id: 'TX', value: 'TX' });
        this.stateTypeList.push({ id: 'UT', value: 'UT' });
        this.stateTypeList.push({ id: 'VA', value: 'VA' });
        this.stateTypeList.push({ id: 'VT', value: 'VT' });
        this.stateTypeList.push({ id: 'WA', value: 'WA' });
        this.stateTypeList.push({ id: 'WI', value: 'WI' });
        this.stateTypeList.push({ id: 'WV', value: 'WV' });
        this.stateTypeList.push({ id: 'WY', value: 'WY' });


        this.titleTypeList.push({ id: 'AXXESSFUNDRASINGCHAIR', value: 'Axxess Fundraising Chair' });
        this.titleTypeList.push({ id: 'EXCDIRECTORORMANAGER', value: 'Exec. Director or Manager' });
        this.titleTypeList.push({ id: 'OFFICEMANAGER', value: 'Office Manager' });
        this.titleTypeList.push({ id: 'OTHER', value: 'Other' });
        this.titleTypeList.push({ id: 'PRINCIPAL', value: 'Principal' });
        this.titleTypeList.push({ id: 'PTAFUNDRASINGCHAIR', value: 'PTA Fundraising Chair' });
        this.titleTypeList.push({ id: 'PTAPRESIDENT', value: 'PTA President' });
        this.titleTypeList.push({ id: 'VOLUNTEER', value: 'Volunteer' });
        this.titleTypeList.push({ id: 'TREASURERORBILLINGCONTACT', value: 'Treasurer or Billing Contact' });

    }

    ngOnInit() {
        this.market = 'SANTA_BARBARA_MARKET';
        this.getSalesRep();
    }

    getSalesRep() {
        const listParams = {
            'filter': {
                'fields': [
                    {
                        'field': 'status',
                        'value': 'ENABLED'
                    },
                ]
            },
            'paging' : {
                'page' : 1,
                'numRows' : 0
            }
        };

        // alert.JSON.stringify(JSON.stringify(listParams));

        this._settingsService.listSalesRep(listParams)
            .subscribe(
                data => {
                    if (data) {
                        data.salesReps.forEach(function (rep) {
                            rep.marketNames.forEach(function (marketName) {
                                if(marketName == 'FUNDRAISING')
                                {
                                    this.salesRepList.push({
                                        id:  rep.id,
                                        value:  rep.name,
                                        order: rep.name === "I'm Not Sure" ? "_" : rep.name
                                    });
                                }
                            }.bind(this));
                        }.bind(this));

                        console.log(JSON.stringify(data));

                        this.salesRepList.sort(function (a, b) {
                            if (a.order > b.order) {
                              return 1;
                            }
                            if (a.order < b.order) {
                              return -1;
                            }
                  
                            return 0;
                          });
      
                        // this.salesRepsMarkets = Object.keys(this.salesRepsList);
                        // this.salesRepsMarkets.sort();
                    }
                }, error => {
                    if (error.message) {
                        this.msg.push({ severity: 'error', detail: error.message });
                    } else {
                        for (let i = 0; i < error.parameterErrors.length; i++) {
                            this.msg.push({ severity: 'error', detail: error.parameterErrors[i].message });
                        }
                    }
                });
    }

    validarCampos(){



        if(!this.createAccount.get('organizationname').valid){
            this.msg.push({ severity: 'error', detail: 'Please enter an Organization Name' });
        }

        if(!this.createAccount.get('organizationtype').valid){
            this.msg.push({ severity: 'error', detail: 'Please select an option for Organization Type' });
        }

        if(!this.createAccount.get('salesRep').valid){
            this.msg.push({ severity: 'error', detail: 'Please select an option for Sales Rep' });
        }

        if(!this.createAccount.get('organizationphone').valid){

            if(this.createAccount.value.organizationphone){
                this.msg.push({ severity: 'error', detail: 'Please enter an valid Organization Phone' });
            }else{
                this.msg.push({ severity: 'error', detail: 'Please enter a Organization Phone' });
            }

        }



        if(!this.createAccount.get('region').valid){
            this.msg.push({ severity: 'error', detail: 'Please select a county' });
        }



        if(!this.createAccount.get('address').valid){
            this.msg.push({ severity: 'error', detail: 'Please enter a value for Address' });
        }

        if(!this.createAccount.get('city').valid){
            this.msg.push({ severity: 'error', detail: 'Please enter a value for City' });
        }


        if(!this.createAccount.get('state').valid){
            this.msg.push({ severity: 'error', detail: 'Please select a value for State' });
        }

        if(!this.createAccount.get('zip').valid){
            this.msg.push({ severity: 'error', detail: 'Please enter a value for Zipcode' });
        } else{

            if (this.createAccount.value.zip.length < 5 ) {
                this.msg.push({ severity: 'error', detail: 'Zipcode must be at least 5 characters' });
            }

            if(!/^[0-9/-]+$/.test(this.createAccount.value.zip)){
                this.msg.push({ severity: 'error', detail: 'Zipcode may only contain integers 0-9 and - character' });
            }

        }

        if(!this.createAccount.get('primarycontact').valid){
            this.msg.push({ severity: 'error', detail: 'Please enter a value for Primary Contact' });
        }

        if(!this.createAccount.get('phone').valid){



            if(this.createAccount.value.phone){
                this.msg.push({ severity: 'error', detail: 'Please enter an valid Contact Phone' });
            }else{
                this.msg.push({ severity: 'error', detail: 'Please enter a value for Contact Phone' });
            }


        }





        if(!this.createAccount.get('email').valid){
            this.msg.push({ severity: 'error', detail: 'Please enter a value for Email' });
        }else{

            if(!this.validateEmail(this.createAccount.value.email)){
                this.msg.push({ severity: 'error', detail: 'Please enter a valid email address' });
            }
        }

        if(!this.createAccount.get('title').valid){
            this.msg.push({ severity: 'error', detail: 'Please enter a value for Title' });
        }


    }



    formatZip(value) {
        if (value == undefined) return '';
        value = value.toString();
        value = value.replace(/[^0-9]/g, '');
        if (value.length > 9) {
            value = value.slice(0, 9);
        }
        if (value.length > 5) {
            value = value.slice(0, 5) + "-" + value.slice(5);
        }

        return value;
    };



    formatZipCode(event){
        console.log(event)
        var keycode = event.keyCode;
        var isTextInputKey =
            (keycode > 47 && keycode < 58) || // number keys
            keycode == 32 || keycode == 8 || // spacebar or backspace
            (keycode > 64 && keycode < 91) || // letter keys
            (keycode > 95 && keycode < 112) || // numpad keys
            (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
            (keycode > 218 && keycode < 223);   // [\]' (in order)
        if (isTextInputKey) {
            if (!event.currentTarget.value || event.currentTarget.value == 0) { return }
            event.currentTarget.value = this.formatZip(event.currentTarget.value);
        }
    }

    formatPhone(event, phone) {
            var x = event.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            event.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }

    // formatPhone(event, phone) {
    //     this.phone = this.commonDataService.formatPhone(event, phone, this.phone);
    // }


    validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }

    formatOrganizationphone(event,organizationphone){
        this.organizationphone =  this.commonDataService.formatPhone(event, organizationphone, this.organizationphone);
    }

    onSubmit() {
        this.msg = [];
        this.submitted = true;

        this.createAccount.value.phone = this.phone;
        this.createAccount.value.organizationphone = this.organizationphone;

        this.validarCampos();

        if (this.createAccount.valid === false) {
            return;
        }

        let userData = this.commonDataService.deleteEmptyObjectProperties(this.commonDataService.trimObjectData(this.createAccount.value));


        let data = this.commonDataService.trimObjectData(this.createAccount.value);
        this.hideUI = true;
        this.fundraisingService.createAccount(data)
            .subscribe(
                data => {
                    this.hideUI = false;
                    this.router.navigate(['/thankyou']);
                },
                error => {
                    this.hideUI = false;
                    if(error.parameterErrors != undefined) {
                        for (let i = 0; i < error.parameterErrors.length; i++) {
                            this.msg.push({ severity: 'error', detail: error.parameterErrors[i].message });
                        }
                    } else if(error.message.length != 0) {
                        this.msg.push({ severity: 'error', detail: error.message });
                    }
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/create-account/create-account.component.ts